import { useEffect, useState } from 'react';
import Page from 'modules/app/components/Page';
import { useNavigate, useParams } from 'react-router-dom';
import s from './SalonDetails.module.scss';
import Button from 'components/shared/Button';
import About from './About/About';
import { ReactComponent as ArrowRight } from 'images/new-icons/arrow-right-grey.svg';
import TopSpecialists from 'modules/salon/pages/Services/TopSpecialists/TopSpecialists';
import useGetServiceByid from 'sdk/hooks/salon/useGetServiceByid';
import useGetAllServicePricingDurationByService from 'sdk/hooks/booking/useGetAllServicePricingDurationByService';
import useGetSalonByid from 'sdk/hooks/salon/useGetSalonById';
import TopMenuForSearch from 'modules/feed/components/Feed/TopMenuForSearchDetails/TopMenuForSearch';
import useGetReviewBySalonId from 'sdk/hooks/salon/useGetReviewBySalonId';
import clsx from 'clsx';
import SalonReviews from './SalonReviews/SalonReviews';
import { useActions } from 'store/useActions';
import { useTranslation } from 'react-i18next';
import { DEFAULT_AVATAR } from 'utils/Constants';
import useGetServiceFinishedByUserAndServiceId from 'sdk/hooks/salon/useGetServiceFinishedByUserAndServiceId';
import useIsAuth from 'sdk/hooks/useIsAuth';

const servicesTitle2 = (text: string) => {
  return (
    <div className={s.services_title}>
      <div className={s.services_title_title}>{text}</div>
    </div>
  );
};

const SalonDetails = () => {
  const { t } = useTranslation() as any;
  const { id } = useParams();
  const { data } = useGetServiceByid(id);

  const { data: isAuthData } = useIsAuth();
  const userId = isAuthData?.user?.id;

  const { data: salon, refetch: salonRefetch } = useGetSalonByid(data?.salon);
  const { data: product, refetch: productRefetch } = useGetAllServicePricingDurationByService(id);
  const { data: reviews, refetch: reviewsRefetch } = useGetReviewBySalonId(data?.salon);
  const { data: service, refetch: serviceDone } = useGetServiceFinishedByUserAndServiceId(
    userId,
    id,
  );

  const { setIsSlideChange } = useActions();

  const navigate = useNavigate();

  const [isBooking, setIsBooking] = useState(false);

  const servicesTitle = (text: string) => {
    return (
      <div className={s.services_title}>
        <div className={s.services_title_title}>{text}</div>
        <div
          className={s.services_title_see_all}
          onClick={() => navigate(`/salon/${salon?.id}/specialists`)}
        >
          <div className={s.services_title_see}>{t('See All')}</div>
          <ArrowRight />
        </div>
      </div>
    );
  };

  const handleCloseMenu = () => {
    navigate(-1);
    setIsBooking(false);
    return;
  };

  useEffect(() => {
    salonRefetch();
    productRefetch();
    reviewsRefetch();
    serviceDone();
    setIsSlideChange(false);
  }, []);

  return (
    <div style={{ overflow: 'auto' }}>
      <Page activeLink="/venues">
        <div className={clsx(s.container, isBooking && s.booking)}>
          <TopMenuForSearch
            handleBack={handleCloseMenu}
            handleShare={() => {
              navigator.share({
                title: 'Share',
                text: 'Share',
                url: window.location.href,
              });
            }}
          />
          <div style={{ height: '24px' }} />
          <div className={s.salon_inf}>
            <img
              className={s.salon_inf_img}
              src={salon?.avatar}
              onClick={() => navigate(`/salon/${salon?.id}`)}
              alt={salon?.first_name}
            />
            <div className={s.salon_inf_name}>{t(salon?.name)}</div>
            <div className={s.salon_inf_service}>{t(data?.name)}</div>
            <div className={s.salon_inf_currency}>{t(data?.service_location)}</div>
          </div>
          <img className={s.product_image} src={data?.image} alt="" />
          <Button
            wide
            darkGreen
            onClick={() =>
              navigate(
                `/appointment-booking/${data?.salon}?serviceLocation=${data?.service_location}&serviceId=${id}`
              )
            }
          >
            {t('Book now')}
          </Button>
          <About product={product} description={data?.description} name={data?.name} />

          <div className={s.specialists_section}>
            {servicesTitle(t('Specialists'))}
            <TopSpecialists salonId={salon?.id} serviceId={id} />
          </div>
          {servicesTitle2(t('Reviews'))}
          {reviews?.length ? (
            reviews
              ?.filter(item => item?.service_id === id)
              ?.map(item => {
                return (
                  <SalonReviews
                    key={item.id}
                    rank={item?.rank}
                    serviceRank={item?.service_rank}
                    text={item?.text}
                    userName={item?.name}
                    userAvatar={
                      item?.name === 'Anonymous'
                        ? DEFAULT_AVATAR
                        : item?.user_profiles?.avatar || DEFAULT_AVATAR
                    }
                    media={item?.media ?? []}
                    likes={item?.likes_amount}
                    reviewsRefetch={reviewsRefetch}
                    reviewId={item?.id}
                  />
                );
              })
          ) : (
            <div className={s.no_reviews}>{t('There are no reviews yet')}</div>
          )}
          <div className={s.actions}>
            {/*<Button wide darkGreen onClick={() => navigate(`/appointment-booking/${data?.salon}`)}>*/}
            {/*  {t('Book now')}*/}
            {/*</Button>*/}
          </div>
        </div>
      </Page>
    </div>
  );
};

export default SalonDetails;
